'use strict';


module.exports = function (client) {

    client.disco.addFeature('urn:xmpp:forward:0');
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/forwarding.js
// module id = 581
// module chunks = 2